/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

const CENTER_GRAPH_COMPARE = "centerGraphCompare";

module.exports = {
    CENTER_GRAPH_COMPARE,
}